module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-9adc8e74.png";